import { extendTheme } from "@chakra-ui/react";
const pairs = {
  page: ["#FFFFFF", "#000000"],
  panel: ["#FFFFFF", "#16181A"],
  elevated: ["#FFFFFF", "#181818"],
  subtle: ["#EDF2F7", "#272727"],
  line: ["#E2E8F0", "#2B2B2B"],
  ink: ["#1A202C", "#F2F2F2"],
  muted: ["#4A5568", "#AAAAAA"],
  brand: ["#4F46E5", "#0072F5"],
  brandHover: ["#4338CA", "#005BCC"],
  selected: ["#EEF2FF", "#10253E"],
  selectedText: ["#3730A3", "#68ACFA"],
  "chakra-body-bg": ["#FFFFFF", "#000000"],
  "chakra-body-text": ["#1A202C", "#F2F2F2"],
  "chakra-border-color": ["#E2E8F0", "#2B2B2B"],
};
export default extendTheme({
  config: { initialColorMode: "light", useSystemColorMode: false },
  semanticTokens: {
    colors: Object.fromEntries(
      Object.entries(pairs).map(([key, [light, dark]]) => [
        key,
        { default: light, _dark: dark },
      ]),
    ),
  },
  styles: {
    global: {
      body: { bg: "page", color: "ink" },
      "*:focus-visible": {
        outline: "2px solid",
        outlineColor: "brand",
        outlineOffset: "3px",
      },
    },
  },
  components: {
    Button: {
      baseStyle: { borderRadius: "10px", fontWeight: 600 },
      variants: {
        solid: { bg: "subtle", color: "ink", _hover: { bg: "line" } },
        brand: {
          bg: "brand",
          color: "white",
          transition: "background-color .15s, box-shadow .15s, transform .1s",
          _light: {
            boxShadow:
              "0 1px 2px rgb(79 70 229 / 0.25), 0 4px 12px -4px rgb(79 70 229 / 0.45), inset 0 1px 0 rgb(255 255 255 / 0.18)",
          },
          _active: { transform: "translateY(1px)" },
          _disabled: { opacity: 0.55 },
          _hover: { bg: "brandHover", _disabled: { bg: "brand" } },
        },
        outline: {
          border: "1px solid",
          borderColor: "line",
          color: "ink",
          _hover: { bg: "subtle" },
        },
        ghost: { color: "muted", _hover: { bg: "subtle", color: "ink" } },
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            bg: "panel",
            borderColor: "line",
            _placeholder: { color: "muted", opacity: 0.85 },
            _focusVisible: {
              borderColor: "brand",
              boxShadow: "0 0 0 1px var(--chakra-colors-brand)",
            },
          },
        },
      },
    },
    Textarea: {
      variants: {
        outline: {
          bg: "panel",
          borderColor: "line",
          _placeholder: { color: "muted", opacity: 0.85 },
          _focusVisible: { borderColor: "brand" },
        },
      },
    },
    Select: {
      variants: { outline: { field: { bg: "panel", borderColor: "line" } } },
    },
    Drawer: { baseStyle: { dialog: { bg: "elevated", color: "ink" } } },
    Modal: { baseStyle: { dialog: { bg: "elevated", color: "ink" } } },
    Menu: {
      baseStyle: {
        list: { bg: "elevated", borderColor: "line" },
        item: { bg: "elevated", _focus: { bg: "subtle" } },
      },
    },
    Tooltip: { baseStyle: { bg: "ink", color: "page" } },
  },
});
